import { adminComponents } from './admin.js';
import { presetCategoryComponents } from './preset-category.js';
import { presetComponents } from './preset.js';
import { recipeComponents } from './recipe.js';
import { segmentPriceComponents } from './segment-price.js';
import { solidColorMaterialComponents } from './solid-color-material.js';
import { woodTextureMaterialComponents } from './wood-texture-material.js';
export const adminGeneratedComponents = [
    ...presetComponents,
    ...adminComponents,
    ...solidColorMaterialComponents,
    ...segmentPriceComponents,
    ...woodTextureMaterialComponents,
    ...presetCategoryComponents,
    ...recipeComponents
];

//# sourceMappingURL=index.js.map